// The three links ops clicks on any driver: call, WhatsApp, address on a map.

/**
 * The 62… form WhatsApp needs, from `08123…`, `628123…` or `+62 812-3…`.
 * Returns null rather than forcing +62 onto a foreign number.
 */
export const toWhatsAppNumber = (raw?: string | null): string | null => {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('+') && !trimmed.startsWith('+62')) return null;
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return null;
  const national = digits.startsWith('62')
    ? digits.slice(2)
    : digits.replace(/^0+/, '');
  // Indonesian mobile numbers run 9–13 digits after the country code.
  if (national.length < 9 || national.length > 13) return null;
  return `62${national}`;
};

export const toWhatsAppUrl = (raw?: string | null): string | null => {
  const number = toWhatsAppNumber(raw);
  return number ? `https://wa.me/${number}` : null;
};

/** `tel:` keeps the number as dialled locally — a phone knows what 08… is. */
export const toTelUrl = (raw?: string | null): string | null => {
  const digits = (raw ?? '').replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : null;
};

/** A written address on Maps as a SEARCH, not a pin: it has no coordinates. */
export const toMapsSearchUrl = (
  ...parts: (string | null | undefined)[]
): string | null => {
  const query = parts
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(', ');
  return query
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
    : null;
};

/** A dropped pin, for coordinates we actually hold. */
export const toMapsPinUrl = (
  latitude?: number | null,
  longitude?: number | null
): string | null =>
  typeof latitude === 'number' && typeof longitude === 'number'
    ? `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
    : null;
